import { render, staticRenderFns } from "./CourseDetails.vue?vue&type=template&id=cb37e48a&scoped=true&"
import script from "./CourseDetails.vue?vue&type=script&lang=js&"
export * from "./CourseDetails.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetails.vue?vue&type=style&index=0&id=cb37e48a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb37e48a",
  null
  
)

export default component.exports